import { createReducer, on } from '@ngrx/store';
import { Project } from '../../models/dbmodels';
import { EventLogViewModel, ProjectSearchRequest } from '../../models/viewmodels';
import {
  clearProjectsSearchRequest,
  loadProjectsFailure,
  loadProjectsSuccess,
  searchProjectsSuccess,
  updateProjectsSearchRequest
} from './projects.actions';

const EMPTY_PROJECT_SEARCH_REQUEST: ProjectSearchRequest = {
  SearchText: '',
  IncludeInactive: false,
  IncludeCurrentUserProjectsOnly: false,
  SortRequest: { SortField: 'DateModified', SortDirection: 'Descending' },
};

const EMPTY_PROJECT: Project = {
  ProjectId: 0,
  IsActive: true,
  Name: '',
  Description: '',
  ExpectedCloseDate: new Date()
};

export interface ProjectsState {
  projects: Project[];
  qtyOfInactiveProjects: number;
  qtyOfActiveProjects: number;
  qtyOfProjects: number;
  qtyOfProjectsForCurrentUser: number;
  searchRequest: ProjectSearchRequest;
  projectEvents?: EventLogViewModel[];
  focusedProject?: Project;
}

export const initialProjectsState: ProjectsState = {
  projects: [],
  qtyOfInactiveProjects: 0,
  qtyOfActiveProjects: 0,
  qtyOfProjects: 0,
  qtyOfProjectsForCurrentUser: 0,
  focusedProject: EMPTY_PROJECT,
  projectEvents: undefined,
  searchRequest: EMPTY_PROJECT_SEARCH_REQUEST,
};

export const projectsFeatureKey = 'projectsState';

export const projectsReducer = createReducer(
  initialProjectsState,
  on(loadProjectsSuccess, (state, { projects }): ProjectsState => {

    const activeProjects = projects.filter(p => p.IsActive);

    return {
      ...state,
      projects: projects,
      qtyOfProjects: projects.length,
      qtyOfActiveProjects: activeProjects.length,
    };
  }),
  on(searchProjectsSuccess, (state, { request, response }): ProjectsState => {
    const projects = (response.Projects ?? []).map(project => ({
      ...project,

      ProjectSchedules: project.ProjectSchedules?.slice().sort((a, b) => {
        const dateA = a.DateModified ? new Date(a.DateModified).getTime() : 0;
        const dateB = b.DateModified ? new Date(b.DateModified).getTime() : 0;
        return dateB - dateA;
      })
    }));

    return {
      ...state,
      projects,
      qtyOfProjects: projects.length + (response.QtyOfInactiveProjects ?? 0),
      qtyOfActiveProjects: projects.length,
      qtyOfInactiveProjects: response.QtyOfInactiveProjects ?? 0,
      qtyOfProjectsForCurrentUser: response.QtyOfProjectsForCurrentUser ?? 0,
      projectEvents: response.EventLogs ?? [],
      searchRequest: request,
    };
  }),
  on(updateProjectsSearchRequest, (state, { searchRequest }): ProjectsState => {
    return {
      ...state,
      searchRequest: {
        ...state.searchRequest,
        ...searchRequest
      },
    };
  }),
  on(clearProjectsSearchRequest, (state: ProjectsState): ProjectsState => {
    return {
      ...state,
      searchRequest: EMPTY_PROJECT_SEARCH_REQUEST
    }
  }),
  on(loadProjectsFailure, (state, { error }): ProjectsState => {
    console.error(error);
    return state;
  }),
);
